import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import CandidateCard from "@/components/candidates/CandidateCard";
import api from "@/lib/api";

export default function SavedProfilesTab() {
  const { t } = useTranslation();
  const [favorites, setFavorites] = useState(null);

  useEffect(() => {
    api.get("/favorites/me").then(({ data }) => setFavorites(data.filter((f) => f.target_type === "candidate")));
  }, []);

  if (!favorites) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#4ba3b7]" /></div>;

  return (
    <div data-testid="producer-saved-profiles-tab">
      {favorites.length === 0 ? (
        <p className="text-center py-16 text-[#2B2B2B]/50" data-testid="producer-saved-profiles-empty-message">{t("search.noResults")}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {favorites.filter((f) => f.candidate).map((f) => <CandidateCard key={f.target_id} candidate={f.candidate} />)}
        </div>
      )}
    </div>
  );
}
